// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: '8f2d7869-511b-4c97-aaaa-4ff4a3875c39',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '0ca97664-708c-42f2-a842-ae527d54a942',
      type: 'Container',
      name: 'wrapper',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '8f2d7869-511b-4c97-aaaa-4ff4a3875c39'
    },
    {
      id: '05d47ae7-c9af-425f-8857-b55228c551bd',
      type: 'Sprite',
      name: 'pointer',
      className: '',
      x: 98,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Item_Blue_Background_Pointer',
      parent: '0ca97664-708c-42f2-a842-ae527d54a942',
      stateByName: {
        premium: {
          texture: 'Item_Gold_Background_Pointer',
          x: -123
        },
        noPointer: {
          visible: false
        }
      }
    },
    {
      id: 'dec9db2a-1491-4159-aa2a-61e01bea898c',
      type: 'Sprite',
      name: 'background',
      className: '',
      x: 0,
      y: 9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Item_Blue_Background_Variation',
      parent: '0ca97664-708c-42f2-a842-ae527d54a942',
      stateByName: {
        premium: {
          texture: 'Item_Gold_Background_Variation',
          y: 7
        }
      }
    },
    {
      id: '449e6dd2-ec4d-497d-b3bc-e7b0f9e00872',
      type: 'Sprite',
      name: 'rays',
      className: 'rotate_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: '0ca97664-708c-42f2-a842-ae527d54a942',
      stateByName: {
        premium: {
          visible: true,
          angle: 0,
          alpha: 1
        }
      }
    },
    {
      id: '601efd64-045b-4ec9-ae84-3c8dcf3a80bb',
      type: 'Sprite',
      name: 'rays2',
      className: 'rotate_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: '0ca97664-708c-42f2-a842-ae527d54a942',
      data: {
        rotationCycle: 28700
      },
      stateByName: {
        premium: {
          visible: true,
          angle: 19.3,
          alpha: 1
        }
      }
    },
    {
      id: '8d3a8adb-b773-4a0e-8f21-b43710ac5adf',
      type: 'Sprite',
      name: 'icon',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.95,
        y: 0.95
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Big_Coin_Icon',
      parent: '0ca97664-708c-42f2-a842-ae527d54a942',
      data: {
        maxSize: 100
      }
    },
    {
      id: '607f9777-b7eb-4b29-828d-5ac447ea44c9',
      type: 'Text',
      name: 'amountText',
      className: '',
      x: 21,
      y: 34,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'xX',
      localize: false,
      maxWidth: 117,
      maxHeight: 75,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '0ca97664-708c-42f2-a842-ae527d54a942'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'premium',
    'noPointer'
  ],
  animations: [
    {
      id: 'cd5b5f61-6584-4bbf-a5d0-8558461978c9',
      name: 'Idle_Reward',
      playingSpeed: 1,
      totalDuration: 2000,
      blocks: [
        {
          id: '866c7b6d-4d26-49fd-b937-e3fb24fa667f',
          type: 'Tween',
          name: 'New_tween_copy',
          duration: 1000,
          track: 1,
          target: {
            pivot: {},
            y: -2
          },
          startAt: 0,
          sourceName: 'icon',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'b26ee0bf-fe2b-4ad6-8116-b0d74149bef1',
          type: 'Tween',
          name: 'New_tween',
          duration: 1000,
          track: 1,
          target: {
            pivot: {},
            y: 0
          },
          startAt: 1000,
          sourceName: 'icon',
          easing: 'SinusoidalInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class SeasonPassRewardLayout {
  static raw = raw;
  root!: Container;
  wrapper!: Container;
  pointer!: Sprite;
  background!: Sprite;
  rays!: Sprite;
  rays2!: Sprite & { data: typeof raw['list'][5]['data'] };
  icon!: Sprite & { data: typeof raw['list'][6]['data'] };
  amountText!: Text;
  rotate_SPL!: (Sprite | Sprite & { data: typeof raw['list'][5]['data'] })[];
  StateName!: 'premium' | 'noPointer';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Idle_Reward {
  Layout: {
    icon: object;
  };

  BlockTypeByName: {
    New_tween_copy: object;
    New_tween: object;
  };

  flowData = raw.animations[0];
}
